// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import {Controller} from "stimulus"
import Shuffle from 'shufflejs'

export default class extends Controller {
  static targets = ['container']

  connect() {
    this.shuffleInstance = new Shuffle(this.containerTarget, {
      itemSelector: '.picture-item',
      speed: 500
    })
  }

  shuffleAll(event) {
    event.preventDefault()
    this.shuffleInstance.filter(Shuffle.ALL_ITEMS)
  }

  shuffleFilter(event) {
    event.preventDefault()
    this.shuffleInstance.filter(event.target.dataset['filter'])
  }

  sortDefault(event) {
    event.preventDefault()
    this.shuffleInstance.sort({})
  }

  sortTitle(event) {
    event.preventDefault()
    let options = {}
    options['by'] = (element) => {
      return element.getAttribute('data-title').toLowerCase()
    }
    this.shuffleInstance.sort(options)
  }

  disconnect() {
    this.shuffleInstance.destroy()
  }
}
